import { formatFilterOptionLabel } from '../lib/filter-labels';
import type { AnalyticHistoricFilter } from '../api/types';

/**
 * El histórico guarda el valor crudo del filtro —el NIT, el código de país— porque es lo que
 * hace falta para repetir la búsqueda. El API le adjunta `labels` con el nombre que esa clave
 * tiene en su maestra, y es ese nombre el que se pinta, como hacía la app vieja.
 */
const labelFor = (filter: AnalyticHistoricFilter, value: string): string => {
  return formatFilterOptionLabel(filter.labels?.[value], value);
};

export const formatFilterValue = (filter: AnalyticHistoricFilter): string => {
  const { matchType, value } = filter;
  if (matchType === 'range' && Array.isArray(value) && value.length === 2) {
    return `${value[0]} Hasta ${value[1]}`;
  }
  if (Array.isArray(value)) {
    return value.length ? labelFor(filter, String(value[0])) : '-';
  }
  return value === undefined || value === null ? '' : labelFor(filter, String(value));
};

export const getFilterValues = (filter: AnalyticHistoricFilter): string[] => {
  const { value } = filter;
  const raw = Array.isArray(value) ? value.map(String) : [String(value ?? '')];
  return raw.filter(Boolean).map(item => labelFor(filter, item));
};
